const datasetConfig = {
  label: "Line",
  data: [5, 2, 3, 5, 6, 1, 3, 6],
  // backgroundColor: "rgb(255, 99, 132)",
  borderColor: "rgb(255, 99, 132)",
  fill: false
};

const config = {
  type: "line",
  data: {
    labels: ["label1", "label2"], // 決定於 x 軸的 label
    datasets: [{ ...datasetConfig }]
  },
  options: {
    title: {
      display: true,
      text: ""
    },
    legend: {
      position: "right"
    },
    scales: {
      xAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: ""
          },
          gridLines: {
            drawOnChartArea: false
          }
        }
      ],
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: ""
          },
          gridLines: {
            drawOnChartArea: false
          }
        }
      ]
    }
  }
};
export const line = {
  datasetConfig,
  config
};
